import RestrictedView from './RestrictedView'

export default RestrictedView
